<template>
  <v-container fluid class="v-snack__wrapper"> 
    <v-layout row wrap> 
      <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :multi-line="multiLine"
        :timeout="getTimeoutTime()"
        :top="true"
      >
        <input 
          id="error-message"
          type="hidden" 
          :value="errorMessage"
        >   
        <v-layout row wrap>  
          <v-flex xs1/>
          <v-flex xs10>
            <b>{{ text }}</b>
           </v-flex>
           <v-flex xs1/>
           <v-flex xs1/>
           <v-flex xs10>
            <v-icon v-if="warningMessage"> mdi-alert </v-icon>
            {{ warningMessage }}
             {{ errorMessage }}
           </v-flex>

           <v-flex xs1/>
           <v-flex xs7></v-flex>
           <v-flex xs1>
            <v-btn v-if="errorMessage"
              depressed small color="error"
              @click="copyErrorMessage"
            >
              Copy
            </v-btn>
           </v-flex>
            <v-flex xs1/>
            <v-flex xs1>
                <v-btn
                depressed small :color="getButtonColor()" 
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-flex>
        </v-layout>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Snackbar',
  components: {},  
  props: {    
  },
  data: () => ({
    snackbar: false,
    multiLine: true,
    text: '',
    errorMessage: ''
  }), 
  computed: {
    
  },      
  mounted() {
    setTimeout(() => {
      this.$radio.$on('error', (error)=>{
        if(error){
          this.snackbar = true;
          this.text = "HTTP"+error.response.data.status + " - " + error.response.data.error +"\n";
          this.errorMessage = error.response.data.message;
        }                        
      });

      this.$radio.$on('success', (message)=>{
        if(message){
          this.snackbar = true;
          this.text = message.message;
          this.errorMessage = "";
        }                        
      });

      this.$radio.$on('warning', (message)=>{
        if(message){
          this.snackbar = true;
          this.text = "";
          this.warningMessage = message.message;
        }                        
      });

    }, 0);
  }, 
  methods: {    
    copyErrorMessage() {
      let textToCopy = document.querySelector('#error-message')
      textToCopy.setAttribute('type', 'text')   
      textToCopy.select()

      document.execCommand('copy');
      
      textToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges();
    },
    getButtonColor () {
      if(this.errorMessage) return 'error'
      else if(this.warningMessage) return 'orange'
      else return 'success'
    },
    getTimeoutTime () {
      if(this.errorMessage) return 20000;
      else return 3000;
    },
  }
}
</script>

<style lang="scss" scoped>

  .v-snack__wrapper {
    max-width: 100% !important;
    width: 100% !important;
    text-align: center !important;      
  }
  .v-snack__content {
    min-width: 500px !important;
    display: block !important;   
  }
</style>
